export * from './requete.model';
export * from '../../shared/services/requete.service';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/requete/index.ts